<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/solicitacao"> Compras/ Solicitação </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="unidadeAdmSelected"
              :items="filteredUnidAdm"
              label="Unidade Administrativa *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Unidade Administrativa é obrigatória']"
              required
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="localSelected"
              :items="filteredLocal"
              label="Local de Entrega *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Local de entrega é obrigatório']"
              required
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-subheader><strong>Prioridade</strong></v-subheader>
            <hr />
            <div class="flex-center">
              <v-radio-group v-model="tipo" row>
                <v-radio label="Normal" value="N"></v-radio>
                <v-radio label="Emergencial" value="E"></v-radio>
              </v-radio-group>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8">
            <v-textarea
              clearable
              auto-grow
              clear-icon="mdi-close-circle"
              label="Observação"
              v-model="observacao" v-uppercase
              maxlength="200"
              counter
              rows="1"
              :rules="[
                (v) =>
                  !v ||
                  v.length <= 200 ||
                  'Observação deve possuir no máximo 200 caracteres',
              ]"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-snackbar v-model="errorMessage" color="error" timeout="3000"
          >{{ errorMessageValue }}
        </v-snackbar>
      </v-form>
      <v-row align="center">
        <v-col class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addProduto()"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar produto</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-form ref="formProd" v-model="valid" lazy-validation>
        <v-card>
          <v-data-table
            :headers="headers"
            hide-default-footer
            :items="produtosL"
            item-key="index"
            :items-per-page="-1"
          >
            <template v-slot:item.codigo="{ item }">
              {{
                item.codigo === null || item.codigo == "" ? "NA" : item.codigo
              }}
            </template>
            <template v-slot:item.quantidade="{ item }">
              <v-text-field
                v-model="item.quantidade"
                hide-details
                dense
                type="number"
                :rules="[validarQuantidadeItem]"
                v-mask="['#####']"
              />
            </template>
            <template v-slot:item.centroCusto="{ item }">
              <div v-if="!item.editingCentroCusto">
                <div
                  @click="item.editingCentroCusto = true"
                  style="cursor: pointer"
                >
                  {{
                    (item.centroCustoSelected &&
                      item.centroCustoSelected.descricao) ||
                    "Selecionar..."
                  }}
                </div>

                <div
                  v-if="item.centroCustoErro"
                  style="color: #b00020; font-size: 12px"
                >
                  O Centro de Custo é obrigatório
                </div>
              </div>

              <v-autocomplete
                v-else
                v-model="item.centroCustoSelected"
                :items="centrosCusto"
                item-text="descricao"
                item-value="id"
                return-object
                :readonly="isAllowed"
                autofocus
                @blur="
                  () => {
                    item.editingCentroCusto = false;
                    item.centroCustoErro = !(
                      item.centroCustoSelected && item.centroCustoSelected.id
                    );
                  }
                "
                @change="
                  (val) => {
                    changeProduto(item, val);
                    item.centroCustoErro = !(val && val.id);
                    item.editingCentroCusto = false;
                  }
                "
                :rules="[
                  (v) => !!(v && v.id) || 'O Centro de Custo é obrigatório',
                ]"
                required
              >
              </v-autocomplete>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mr-2" color="info" v-bind="attrs" v-on="on">
                    info
                  </v-icon>
                </template>
                <span
                  >Caso o Centro de Custo não seja encontrado na lista, um novo
                  equipamento deverá ser cadastrado.</span
                >
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="info"
                    @click="editaProduto(item.index)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="error"
                    @click="removeProduto(item.index)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-thick
                  </v-icon>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
            <template v-slot:item.index="{ item }">
              {{ item.index + 1 }}
            </template>
            <template v-slot:body.append>
              <tr>
                <td
                  :colspan="headers.length"
                  class="text-right font-weight-medium"
                >
                  Total de itens: {{ produtosL.length }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-speed-dial bottom right fixed>
            <template v-slot:activator>
              <v-btn v-model="fab" color="blue darken-2" dark fab>
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>done</v-icon>
              </v-btn>
            </template>
            <v-btn @click="enviar" color="success" class="mr-4">Salvar</v-btn>
            <v-btn to="/solicitacao" color="error" class="mr-4">Voltar</v-btn>
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline">Adicionar Produto</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form2" v-model="validFrm2" lazy-validation>
              <produto
                ref="prdAdd"
                :produtosL="produtosL"
                :showModal="showModal"
              />
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions
          style="position: sticky; bottom: 0; background: white; z-index: 1"
        >
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModal = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Modal
      v-model="showModalProduto"
      modalStyle="max-width: 1000px"
      title="Editar produto"
      @after-open="updateProduto()"
    >
      <edita-produto ref="editprd"></edita-produto>
      <v-row>
        <v-col align="right">
          <v-btn
            @click="showModalProduto = false"
            depressed
            color="error"
            :style="{
              backgroundColor: '#ff5252 !important',
              color: 'white !important',
              margin: '0px 10px 0px 0px',
            }"
            text
          >
            Voltar
          </v-btn>
          <v-btn
            @click="atualizar"
            color="success"
            :style="{
              backgroundColor: '#4caf50 !important',
              color: 'white !important',
            }"
            text
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </Modal>
  </div>
</template>

<script>
import { enviarSolicitacaoAsync } from "../../../services/solicitacaoService";
import { getUserName } from "../../../services/loginService";
import { mapState, mapActions } from "vuex";
import Produto from "../Produto";
import EditaProduto from "../EditaProduto";

export default {
  name: "criarSolicitacao",
  data: () => ({
    tipo: "N",
    overlay: false,
    valid: true,
    descricao: null,
    observacao: null,
    localSelected: null,
    unidadeAdmSelected: null,
    produtosL: [],
    indexEdit: null,
    showModal: false,
    showModalProduto: false,
    errorMessage: false,
    errorMessageValue: null,
    headers: [
      { text: "Item", value: "index", sortable: false },
      { text: "Produto", value: "descricao", sortable: false },
      { text: "Cod. Fabricante", value: "codigo", sortable: false },
      { text: "Und.", value: "unidadeMedida", sortable: false },
      { text: "Departamento", value: "departamento", sortable: false },
      { text: "Detalhamento", value: "observacao", sortable: false },
      { text: "Quantidade", value: "quantidade", sortable: false },
      {
        text: "Centro de Custo",
        align: "start",
        value: "centroCusto",
        title: "tooltip",
      },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("unidadeAdm", ["unidadesAdm"]),
    ...mapState("local", ["locais"]),
    ...mapState("centroCusto", ["centrosCusto"]),
    filteredLocal() {
      return this.locais.filter((lc) => {
        return (
          (lc.idTipoLocais === 1 || lc.idTipoLocais === 3) && lc.ativo === true
        );
      });
    },
    filteredUnidAdm() {
      return this.locais.filter((lc) => {
        return (
          (lc.idTipoLocais === 2 || lc.idTipoLocais === 3) && lc.ativo === true
        );
      });
    },
  },
  methods: {
    ...mapActions("solicitacao", ["atualizarSolicitacoes", "addSolicitacao"]),
    ...mapActions("produto", ["atualizarListaProdutos"]),
    async enviar() {
      const quantidadesOk = this.validarQuantidadeItens();

      if (!quantidadesOk) {
        this.errorMessageValue =
          "Informe uma quantidade maior que zero em todos os itens.";
        this.errorMessage = true;
        if (this.$store) {
          this.$store.dispatch("ui/showSnackbar", {
            text: "Informe uma quantidade maior que zero em todos os itens.",
            color: "error",
            timeout: 3000,
          });
        }
        return;
      }

      const centrosOk = this.validarCentroCustoItens();

      if (!centrosOk) {
        this.errorMessageValue =
          "Preencha o Centro de Custo em todos os itens.";
        this.errorMessage = true;
        return;
      }
      if (this.produtosL == null || this.produtosL.length <= 0) {
        this.errorMessageValue = "Adicione os produtos à solicitação!";
        this.errorMessage = true;
        return;
      } else if (this.$refs.form.validate() && this.$refs.formProd.validate()) {
        if (
          !(
            this.produtosL.every((item) =>
              Number.isInteger(item.idDepartamento)
            ) && new Set(this.produtosL.map((x) => x.idDepartamento)).size === 1
          )
        ) {
          try {
            const qtdValoresDistintos = new Set(
              this.produtosL.map((item) => item.idDepartamento)
            ).size;
            await this.$confirm(
              "Há produtos de departamentos diferentes, essa solicitação será desmembrada em " +
                qtdValoresDistintos +
                " solicitações .",
              "Confirmação",
              {
                confirmButtonText: "OK",
                cancelButtonText: "Cancelar",
                type: "warning",
              }
            );
          } catch (e) {
            return;
          }
        }
        this.overlay = true;
        try {
          const resposta = await enviarSolicitacaoAsync(
            0,
            this.tipo,
            this.unidadeAdmSelected.id,
            this.localSelected.id,
            this.observacao,
            this.produtosL
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            if (
              this.produtosL.every((item) =>
                Number.isInteger(item.idDepartamento)
              ) &&
              new Set(this.produtosL.map((x) => x.idDepartamento)).size === 1
            ) {
              this.addSolicitacao(this.mountObjSolicitacao(resposta.data));
            } else {
              await this.atualizarSolicitacoes();
            }
            this.$store.dispatch("ui/showSnackbar", {
              text: "Salvo com sucesso!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push("/solicitacao");
          }
        } finally {
          this.overlay = false;
        }
      } else {
        this.errorMessageValue = "Preencha os locais!";
        this.errorMessage = true;
        return;
      }
    },

    addProduto: function () {
      this.showModal = true;
    },
    disable(value) {
      return (
        Object.prototype.toString.call(value) === "[object Array]" &&
        !(JSON.stringify(value) === "[]")
      );
    },
    removeProduto(index) {
      this.produtosL = this.produtosL.filter((p) => p.index != index);
    },
    editaProduto(index) {
      this.indexEdit = index;
      this.showModalProduto = true;
    },
    changeProduto(item, centroCusto) {
      item.idCentroCusto = centroCusto.id;
      item.centroCusto = centroCusto.descricao;
    },
    updateProduto() {
      var produto = this.produtosL.filter((p) => p.index === this.indexEdit);
      this.$refs.editprd.updateObject2(produto[0]);
    },

    atualizar: function (e) {
      var produtoValido = this.$refs.editprd.updateObjectEstate();
      if (!produtoValido) {
        e.preventDefault();
        this.errorMessageValue = "Informe a quantidade!";
        this.errorMessage = true;
        return;
      }
      const produto = this.produtosL.find((p) => p.index === this.indexEdit);
      if (produto) {
        produto.quantidade = this.$refs.editprd.quantidade;
        produto.observacao = this.$refs.editprd.observacao;
      }
      this.showModalProduto = false;
    },
    mountObjSolicitacao(newsol) {
      var solicitacao = new Object();
      solicitacao.id = newsol.id;
      solicitacao.observacao = this.observacao;
      solicitacao.status = "AA";
      solicitacao.prioridade = this.tipo == "N" ? "Normal" : "Emergencial";
      solicitacao.idUnidadeAdm = this.unidadeAdmSelected.id;
      solicitacao.idLocalEntrega = this.localSelected.id;
      solicitacao.unidadeAdm = this.unidadeAdmSelected.descricao;
      solicitacao.local = this.localSelected.descricao;
      solicitacao.ativo = true;
      solicitacao.solicitante = getUserName();
      solicitacao.dataCriado = new Date();
      solicitacao.produtos = newsol.produtos;
      solicitacao.mesmoSolicitante = true;
      solicitacao.idDepartamento = this.produtosL?.[0]?.idDepartamento;

      switch (newsol.id.toString().length) {
        case 1:
          solicitacao.nome = "SL00000" + newsol.id;
          break;
        case 2:
          solicitacao.nome = "SL0000" + newsol.id;
          break;
        case 3:
          solicitacao.nome = "SL000" + newsol.id;
          break;
        case 4:
          solicitacao.nome = "SL00" + newsol.id;
          break;
        case 5:
          solicitacao.nome = "SL0" + newsol.id;
          break;
        default:
          solicitacao.nome = "SL" + newsol.id;
      }

      return solicitacao;
    },
    async obterListas() {
      await this.atualizarListaProdutos();
    },
    validarQuantidadeItem(quantidade) {
      return Number(quantidade) > 0 || "A quantidade deve ser maior que zero";
    },
    validarQuantidadeItens() {
      return this.produtosL.every(
        (item) => this.validarQuantidadeItem(item.quantidade) === true
      );
    },
    validarCentroCustoItens() {
      this.produtosL.forEach((i) => {
        if (i.centroCustoSelected && i.centroCustoSelected.id) {
          i.idCentroCusto = i.centroCustoSelected.id;
          i.centroCusto = i.centroCustoSelected.descricao;
        }

        i.centroCustoErro = !(i.centroCusto && i.idCentroCusto);
      });

      return this.produtosL.every((i) => i.centroCusto && i.idCentroCusto);
    },
  },
  created: function () {
    this.obterListas();
  },
  watch: {
    showModalProduto(visible) {
      if (visible) {
        this.updateProduto();
      }
    },
  },
  components: {
    Produto,
    EditaProduto,
  },
};
</script>
<style scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
